import InfiniteScroll from "react-infinite-scroll-component";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ReactComponent as Search } from "../../../assets/icons/search2.svg";

export const MainContainer = styled.div`
  flex-direction: column;
  background: white;
  min-height: 100vh;
  height: 100%;
  display: flex;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100dvh - 247px);
  margin-top: 145px;

  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  transition: all 0.3s ease-in-out;

  padding: 20px;

  @media (max-width: 1440px) {
    width: 100%;
  }
  @media (max-width: 1256px) {
    margin-top: 130px;
  }

  @media (max-width: 870px) {
    margin-top: 83px;
  }
  @media (max-width: 380px) {
    margin-top: 69.34px;
  }
`;
export const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 1000000;
  width: 100%;
  justify-content: center;
`;
export const Layout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 75px;
  justify-content: center;

  flex-direction: column;
  transition: all 0.3s ease-in-out;

  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "8rem 30rem 8rem 4rem"
          : "8rem 4rem 8rem 30rem"
        : !props.$ar
          ? "8rem 4rem 8rem 10rem"
          : "8rem 10rem 8rem 4rem"
      : "8rem 4rem"};

  @media (max-width: 1440px) {
    width: 100%;
  }
  @media (max-width: 870px) {
    padding: 8rem 0px;
  }
`;

export const Column = styled.div`
  flex-direction: column;
  display: flex;
  transition: all 0.2s ease-in-out;
  width: ${(props) => (props.$loggedIn ? "1800px" : "1440px")};
  padding: 4rem;
`;

export const CardProductMockup = styled.div`
  gap: 10px;
  cursor: pointer;
  border: 1px solid rgb(1, 1, 1, 0.15);
  width: 215px;
  height: 350px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 20px;
  -webkit-box-shadow: 0px 0px 15px 5px rgba(1, 1, 1, 0.05);
  -moz-box-shadow: 0px 0px 15px 5px rgba(1, 1, 1, 0.05);
  box-shadow: 0px 0px 15px 5px rgba(1, 1, 1, 0.05);
  &:hover {
    transition: transform 0.2s ease-out;
    transform: scale(1.1);
    -webkit-box-shadow: 0px 0px 30px 5px rgba(1, 1, 1, 0.1);
    -moz-box-shadow: 0px 0px 30px 5px rgba(1, 1, 1, 0.1);
    box-shadow: 0px 0px 30px 5px rgba(1, 1, 1, 0.1);
  }
`;

export const ProductNameContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  background-color: #e8dbdf;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 15px 15px 20px 15px;
  margin-top: auto;
  gap: 10px;
  width: 100%;
`;
export const ProductPrice = styled.span`
  font-family: "Avenir-Heavy";
  font-size: 24px;
  cursor: default;
  letter-spacing: -0.41px;
  color: #343456;
`;
export const ColorRow = styled.div`
  padding: 0px 15px;
  display: flex;
  gap: 6px;
`;

export const Button = styled.button`
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
  border: transparent;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
  background: #484888;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 18px;
  font-family: "Avenir-Medium";
`;

export const ButtonBack = styled.button`
  cursor: pointer;
  user-select: none;
  border: transparent;
  background: transparent;
  color: #484888;
  font-size: 16px;
  text-transform: uppercase;
  font-family: "Avenir-Medium";
  &:active {
    opacity: 0.75;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 80px 0px 80px 0px;
  @media (max-width: 925px) {
    justify-content: center;
  }
`;

export const BackContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

export const IconRotate = styled.div`
  transform: rotate(90deg);
  margin-right: -10px;
`;

export const ImagePadding = styled.div`
  height: 100%;
  padding-top: 30px;
`;

export const Image = styled.img`
  height: 150px;
  user-select: none;
  max-width: 100%;
`;

export const Sizes = styled.span`
  font-family: "Avenir-Heavy";
  font-size: 14px;
`;
export const Circle = styled.div`
  border-radius: 50%;
  cursor: pointer;
  border: 1.5px solid #fff;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  width: 32px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  border-radius: 25%;
  /* box-shadow: 0px 0px 5px 2.5px rgba(0, 0, 0, 0.15); */
  cursor: pointer;
`;
export const Icons = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  padding: 5px;
  flex-direction: row;
  align-items: center;
  right: 2px;
  top: 2px;
  gap: 6px;
  z-index: 20;
`;
export const ClickContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  top: 4rem;
  border-radius: 2rem;
  cursor: pointer;
`;
export const SectionTitle = styled.h1`
  color: #484888;
  font-family: "Avenir";
  margin-top: 40px;
  font-size: 35px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  z-index: 1000;
  letter-spacing: -0.178px;
  @media (max-width: 870px) {
    display: none;
  }
`;
export const DotsContainer = styled.div`
  position: absolute;
  z-index: 20;
  bottom: 85px;
`;
export const ImageContainer = styled.div`
  display: flex;
  cursor: pointer;
  margin-bottom: -10px;

  @media (max-width: 335px) {
    width: 100%;
  }
`;
export const ImageDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  @media (max-width: 335px) {
    width: 100%;
  }
`;
export const Img = styled(LazyLoadImage)`
  width: 300px;
  height: 291px;
  object-fit: ${(props) => (props.$contain ? "contain" : "cover")};
  border-top-right-radius: 2rem;
  border-top-left-radius: 2rem;
  user-select: none;
  pointer-events: none;
  @media (max-width: 335px) {
    width: 100%;
  }
`;
export const SortContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow-x: auto !important;

  &&::-webkit-scrollbar {
    height: 3.8px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
  }

  &&::-webkit-scrollbar-track {
    background-color: transparent;
  }

  gap: 10px;
  max-width: 80%;

  overflow: visible;
  opacity: ${(props) => (props.$open ? 1 : 0)};

  padding-inline: 5px;
`;

export const SortName = styled.span`
  color: ${(props) => (props.selected ? "#fff" : "rgba(255, 250, 250, 0.85)")};
  user-select: none;
  text-align: center;
  font-family: "Avenir-Medium";
  font-size: 13.8px;
  letter-spacing: 0.067px;
  display: flex;
  font-weight: ${(props) => (props.selected ? "600" : "400")};
  cursor: pointer;

  padding: 5px 1.6rem;
  border-radius: 10px;

  transition: all 0.2s ease-in-out;

  text-shadow: ${(props) =>
    props.selected ? "0px 0px 10px rgba(255, 255, 255, 0.75)" : "none"};
  &:hover {
    text-shadow: 0px 0px 10px rgba(255, 255, 255, 0.75);
  }
`;

export const StyledInfinityScroll = styled(InfiniteScroll)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding-bottom: 10rem;
  flex: 1;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  @media (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 870px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  @media (max-width: 570px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    /* grid-template-columns: repeat(2, 1fr); */
    gap: 10px;
  }
`;

export const ContentWithFilters = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  width: 100%;
  max-width: 100%;

  @media (max-width: 870px) {
    flex-direction: column;
  }
`;

export const FiltersContainer = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  position: sticky;
  top: ${(p) => (p.$open ? "calc(140px + 4rem)" : "4rem")};
  align-self: flex-start;
  width: 280px;
  min-width: 280px;
  flex-shrink: 0;
  background: white;
  z-index: 10;

  @media (max-width: 870px) {
    display: none;
  }
`;

export const CardProduct = styled.div`
  border-radius: 2rem;
  position: relative;
  background: transparent;
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: all 0.3s ease-in-out;
  z-index: 10;

  &:hover {
    z-index: 50;
    transform: scale(0.95);
  }
  @media (max-width: 570px) {
    max-width: 48%;
  }
`;

export const CardProductImage = styled.div`
  border-radius: 2rem;
  width: 100%;
  aspect-ratio: 1 / 1;
  transition: all 0.3s ease-in-out;
  z-index: 10;
  background-image: ${({ $imageUrl, $loaded }) =>
    $loaded ? `url(${$imageUrl})` : "none"};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #e8e8e8;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 2rem;
    background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    opacity: ${({ $loaded }) => ($loaded ? 0 : 1)};
    transition: opacity 0.3s ease;
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;
export const CardProductName = styled.span`
  color: #0f172a;
  font-family: "Avenir";
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0.067px;
`;
export const ProductInfo = styled.div`
  padding: 15px 0px;
  z-index: 20;
  cursor: pointer;
  /* border-radius: 1rem 1rem 2rem 2rem; */
  background: transparent;
  gap: 6px;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 73px;
  /* box-shadow: 0px -5px 4px 0px rgba(0, 0, 0, 0.05); */
  /* position: absolute; */
  margin-top: auto;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const Price = styled.span`
  color: #5d4e8c;
  font-family: "Avenir";
  font-weight: 700;
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.067px;
`;

export const EndMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 446px) {
    align-items: center;
  }
  @media (max-width: 390px) {
    align-items: flex-start;
  }
  @media (max-width: 366px) {
    align-items: center;
  }
`;
export const EndMessageText = styled.span`
  font-family: "Avenir-Heavy";
  font-size: 1.2rem;
  letter-spacing: -0.2px;
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-block: 50px;
`;
export const StyledText = styled(SortName)`
  margin-top: 50px;
  font-size: 22px;
`;
export const StyledBackContainer = styled.div`
  margin-top: -40px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const BackRow = styled(StyledBackContainer)`
  cursor: pointer;
  margin-top: 0;
`;
export const BackText = styled.span`
  color: #484888;
  user-select: none;
  font-family: "Avenir-Medium";
  font-size: 2rem;
  text-transform: uppercase;
  letter-spacing: 0.067px;
`;
export const Text = styled.span`
  color: #484888;
  user-select: none;
  font-family: "Avenir-Medium";
  font-size: 2rem;

  letter-spacing: 0.067px;
  text-align: center;
  margin-top: 8rem;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 110px;
`;

export const Subtitle = styled.span`
  color: #484888;
  font-family: "Avenir-Medium";
  font-size: 2.5rem;
  line-height: 3.2rem;
  text-align: center;
  margin-top: 80px;

  @media (max-width: 645px) {
    font-size: 2rem;
    text-align: center;
  }
`;
export const NumOfProductsContainer = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: row;
  z-index: 5;
  margin: 20px 0px 10px 0px;
  padding-left: 30rem;
  @media (max-width: 1256px) {
    padding-left: 33.5rem;
  }
  @media (max-width: 870px) {
    padding-left: 0;
  }
`;
export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const NumOfProducts = styled.span`
  color: #484888;
  font-family: "Avenir-Light";
  font-size: 16px;
  line-height: 3.2rem;
  /* margin-right: 1px; */
`;
export const NumOfProductsTotal = styled(NumOfProducts)`
  font-family: "Avenir-Heavy";
`;

export const StyledMenuContainer = styled.div`
  background-color: #3a3a6d;
  transition: all 0.2s ease-out;
  height: ${(props) => (props.$open ? "46px" : "0px")};
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: -1;

  left: 0;
  right: 0;

  opacity: ${(props) => (props.$open ? 1 : 0)};
  padding-left: ${(props) =>
    props.$loggedIn && props.$ar
      ? "0px"
      : props.$loggedIn && !props.$ar
        ? "250px"
        : "0px"};
  padding-right: ${(props) =>
    props.$loggedIn && props.$ar
      ? "250px"
      : props.$loggedIn && !props.$ar
        ? "0px"
        : "0px"};

  @media (max-width: 1200px) {
    top: ${(props) => (props.$upgradePackage ? "115px" : "67px")};
  }

  @media (max-width: 870px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const AdminHeaderContainer = styled.div`
  width: 100%;
  margin-top: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
`;
export const AppLoaderContainer = styled.div`
  padding: 5rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GiftBoxImageContainer = styled.div`
  padding: 0px 40px;
  position: relative;
  display: flex;
  justify-content: center;
`;
export const GiftBoxImage = styled(LazyLoadImage)`
  user-select: none;
  background-color: transparent;
  height: 550px;
  border-radius: 21px;
  width: 100%;
  max-width: 1440px;
  object-fit: contain;

  @media (max-width: 870px) {
    height: auto;
    min-height: 32rem;
  }

  @media (max-width: 525px) {
    display: none;
  }
`;

export const FilterWrapper = styled.div`
  gap: 1rem;
  display: flex;
  flex-direction: column;
`;
export const FilterSearch = styled.input`
  outline: none;
  width: 100%;
  border: none;
  padding-right: 2rem;
  border-bottom: 1px solid black;
  color: #484888;
  font-size: 1.4rem;
  font-family: "Avenir-Medium";
`;
export const Filter = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  gap: 1rem;
`;
export const FilterLabel = styled.span`
  color: #484888;
  user-select: none;
  font-size: 1.4rem;
  font-family: "Avenir-Medium";
`;

export const FilterTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
`;

export const FilterTitle = styled.span`
  font-size: 2rem;
  font-family: "Avenir-Heavy";
  color: #484888;
`;

export const SearchIcon = styled(Search)`
  position: absolute;
  cursor: ${(props) => (props.$active ? "pointer" : "default")};
  right: 0rem;
  width: 18px;
  height: 18px;
  top: 50%;
  transform: translateY(-50%);
  path {
    fill: ${(props) => (props.$active ? "#484888" : "#5F6368")};
    fill-opacity: ${(props) => (props.$active ? 1 : 0.25)};
  }
`;

export const FilterSearchContainer = styled.div`
  position: relative;
`;

export const CategoriesRow = styled.div`
  display: none;
  flex-direction: row;
  margin-bottom: 8px;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding-bottom: 12px;
  overflow-x: auto;

  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background-color: #48488820;
  }

  &::-webkit-scrollbar-thumb {
    cursor: grab;
    background-color: rgba(72, 72, 136, 0.8);
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(72, 72, 136, 0.6);
  }
  &::-webkit-scrollbar-thumb:active {
    background-color: #484888;
    cursor: grabbing;
  }
  @media (max-width: 870px) {
    display: flex;
  }
`;

export const Category = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  white-space: nowrap;
  padding: 8px 24px;
  cursor: pointer;
  background: ${(p) => (p.$active ? "#4c4d93" : "#F3F4F6")};

  color: ${(p) => (p.$active ? "#fff" : "#4B5563")};
  font-family: "Avenir-Medium";
  font-size: 14px;
`;
